import React from "react";

export default function Section4() {
    return (
        <div className="w-full Section3 px-5 md:px-0 pt-[2%]">
            <div className="flex flex-col items-center w-full md:flex-row justify-evenly section3-container">
                <div className="w-full md:w-[36%] text-[#373737]">
                    <h2 className="text-[26px] md:text-[34px] font-bold leading-[32px] md:leading-[41px] text-[#DA2128] my-[0.67em] pb-[2%]">
                       Texas Shopify Plus Design Agency for Enterprise-Grade Stores 
                    </h2>
                    <p className="leading-[20px] pb-[1%] text-base mb-5">
                       Our Shopify Plus designers create enterprise-grade storefronts with high performance and seamless UX. We build custom themes, responsive layouts, and engaging page designs that guide users and optimize conversions. Our scalable solutions support complex enterprise operations, ensuring stores enable multi-channel readiness, long-term growth, and a smooth, user-focused shopping experience.

                    </p>
                     {/* <p className="leading-[20px] pb-[1%] text-base mb-5">
                       We deliver full Shopify Plus implementations including custom storefront development, system integrations, and enterprise-level architecture planning. Whether you are upgrading from standard Shopify or migrating from another ecommerce platform, our Shopify Plus development process is designed to support long-term business growth.
                    </p> 
                    <p className="leading-[20px] pb-[1%] text-base mb-5">
                       As a reliable Shopify Plus partner agency, we ensure that every store we develop provides strong performance, secure checkout experiences, and seamless navigation for customers across devices.
                    </p>   
                    <p className="leading-[20px] pb-[1%] text-base mb-5">
                       Ready to scale with Shopify Plus? Mean3 helps New York brands build high-growth ecommerce stores.
                    </p>      */}
                    

                </div>

                <div className="w-full md:w-auto">
                    <img
                        src="../../../assets/computer-shopify.png"
                        alt="Computer Logo"
                        className="w-full md:w-auto cover"
                    />
                </div>
            </div>
            <div className="line my-[55px] md:my-[4%] mx-auto w-[70%] md:w-[61%] shadow-line h-2 rounded-[100%]"></div>
        </div>
    );
}
